"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _address = require("@/api/address");
var _customer = require("@/api/customer");
var _skinStatus = require("@/api/skin-status");
var _vuePropertyDecorator = require("vue-property-decorator");
var _FilterOrder = require("./FilterOrder.vue");
var _order = require("@/types/order");
var _depositOrder = require("@/api/depositOrder.api");
var CustomerOrderForm = /*#__PURE__*/function (_Vue) {
  function CustomerOrderForm() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerOrderForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, CustomerOrderForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "form", void 0);
    (0, _defineProperty2.default)(_this, "orderStatus", void 0);
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "checkCustomerMonthBirthday", void 0);
    (0, _defineProperty2.default)(_this, "disabled", void 0);
    (0, _defineProperty2.default)(_this, "compare", void 0);
    (0, _defineProperty2.default)(_this, "statusForm", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "usingCustomerAddress", false);
    (0, _defineProperty2.default)(_this, "OrderType", _order.OrderType);
    (0, _defineProperty2.default)(_this, "cities", []);
    (0, _defineProperty2.default)(_this, "districts", []);
    (0, _defineProperty2.default)(_this, "wards", []);
    (0, _defineProperty2.default)(_this, "skins", []);
    (0, _defineProperty2.default)(_this, "depositOrders", []);
    (0, _defineProperty2.default)(_this, "rules", {
      customerId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      addressCityId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      addressDistrictId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      addressWardId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      receiverPhone: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      receiverAddress: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      depositOrderId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "OrderStatus", _FilterOrder.OrderStatus);
    (0, _defineProperty2.default)(_this, "customers", []);
    return _this;
  }
  (0, _inherits2.default)(CustomerOrderForm, _Vue);
  return (0, _createClass2.default)(CustomerOrderForm, [{
    key: "created",
    value: function created() {
      this.fetchCustomers();
      this.fetchCities();
      this.fetchSkins();
    }
  }, {
    key: "handleCreateCustomer",
    value: function handleCreateCustomer() {
      this.$refs.customerModal.handleCreate();
    }
  }, {
    key: "handleChangeUsingAddress",
    value: function handleChangeUsingAddress() {
      if (!this.usingCustomerAddress) {
        this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), {}, {
          addressCityId: null,
          addressDistrictId: null,
          addressWardId: null
        });
      } else {
        if (this.form.customerId) {
          this.handleChangeCustomer();
        }
      }
    }
  }, {
    key: "watchCity",
    value: function watchCity() {
      this.fetchDistricts();
    }
  }, {
    key: "watchDistrictId",
    value: function watchDistrictId() {
      this.fetchWards();
    }
  }, {
    key: "watchDistrict",
    value: function watchDistrict() {
      this.fetchWards();
    }
  }, {
    key: "watchCustomerId",
    value: function watchCustomerId(val) {
      // if (val && this.type == OrderType.Consign) {
      //   this.fetchListDepositOrder(val);
      // }
    }
  }, {
    key: "handleChangeDistrict",
    value: function handleChangeDistrict() {
      this.form.addressWardId = null;
    }
  }, {
    key: "handleChangeCity",
    value: function handleChangeCity() {
      this.$set(this.form, "addressDistrictId", null);
      this.$set(this.form, "addressWardId", null);
    }
  }, {
    key: "fetchCities",
    value: function () {
      var _fetchCities = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _address.addressApi.findCity();
            case 2:
              res = _context.sent;
              this.cities = res.data.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchCities() {
        return _fetchCities.apply(this, arguments);
      }
      return fetchCities;
    }()
  }, {
    key: "fetchDistricts",
    value: function () {
      var _fetchDistricts = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this2 = this;
        var city, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              city = this.cities.find(function (e) {
                return e.id == _this2.form.addressCityId;
              });
              if (!city) {
                _context2.next = 6;
                break;
              }
              _context2.next = 4;
              return _address.addressApi.findDistrict({
                parentCode: city.code
              });
            case 4:
              res = _context2.sent;
              this.districts = res.data.data;
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchDistricts() {
        return _fetchDistricts.apply(this, arguments);
      }
      return fetchDistricts;
    }()
  }, {
    key: "fetchWards",
    value: function () {
      var _fetchWards = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _this3 = this;
        var district, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              district = this.districts.find(function (e) {
                return e.id == _this3.form.addressDistrictId;
              });
              if (district) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              _context3.next = 5;
              return _address.addressApi.findWard({
                parentCode: district.code
              });
            case 5:
              res = _context3.sent;
              this.wards = res.data.data;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchWards() {
        return _fetchWards.apply(this, arguments);
      }
      return fetchWards;
    }()
  }, {
    key: "handleChangeCustomer",
    value: function () {
      var _handleChangeCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var res, customer;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$set(this.form, "depositOrderId", null);
              if (this.type == _order.OrderType.Consign) {
                this.$set(this.form, "products", []);
              }
              _context4.next = 4;
              return _customer.customerApi.findOne(this.form.customerId);
            case 4:
              res = _context4.sent;
              customer = res.data.customer;
              if (customer) {
                this.$set(this.form, "skinStatusIds", customer.skinStatuses && customer.skinStatuses.map(function (e) {
                  return e.id;
                }));
                this.$set(this.form, "detailCustomer", res.data);
                if (this.usingCustomerAddress) {
                  this.$set(this.form, "addressCityId", customer.addressCity.id);
                  this.$set(this.form, "addressDistrictId", customer.addressDistrict.id);
                  this.$set(this.form, "addressWardId", customer.addressWard.id);
                  this.form.receiverName = customer.name;
                  this.form.receiverPhone = customer.phone;
                  this.form.receiverAddress = customer.address;
                }
              }
              this.$emit("checkCustomerRank");
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleChangeCustomer() {
        return _handleChangeCustomer.apply(this, arguments);
      }
      return handleChangeCustomer;
    }() // ** Xu li chon hàng ký gửi
  }, {
    key: "handleChangeDepositOrder",
    value: function handleChangeDepositOrder() {
      var _this4 = this;
      var products = [];
      var find = this.depositOrders.find(function (e) {
        return e.id == _this4.form.depositOrderId;
      });
      this.$set(this.form, "depositOrderDetails", find.depositOrderDetails);
      for (var i = 0; i < find.depositOrderDetails.length; i++) {
        var orderDetail = find.depositOrderDetails[i];
        var discountInput = 0;
        var tabDiscount = "";
        if (this.form.detailCustomer && this.form.detailCustomer.customer.customerRank && this.form.detailCustomer.customer.customerGroup && this.form.detailCustomer.customer.name == "Retail") {
          discountInput = this.form.detailCustomer.customer.customerRank.discountPercent || 0;
          tabDiscount = this.form.detailCustomer.customer.customerRank.discountPercent ? "percent" : "";
        }
        var productData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, orderDetail.product), {}, {
          lotNumber: orderDetail.lotNumber,
          expired: orderDetail.expired,
          dateOfManufacture: orderDetail.dateOfManufacture,
          productQuantity: orderDetail.quantity - orderDetail.sold,
          discountInput: discountInput,
          tabDiscount: tabDiscount,
          quantity: orderDetail.quantity - orderDetail.sold,
          totalPrice: 0,
          commissionAmount: 0,
          product: orderDetail.product,
          depositOrderDetailId: orderDetail.id,
          maxQuantity: orderDetail.quantity - orderDetail.sold
        });
        products.push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, productData), {}, {
          realPrice: orderDetail.product.retailPrice
        }));
      }
      this.$set(this.form, "products", products);
    }
  }, {
    key: "fetchListDepositOrder",
    value: function () {
      var _fetchListDepositOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(customerId) {
        var _res$data$depositOrde,
          _this5 = this;
        var res, find;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _depositOrder.depositOrderApi.findAll({
                page: 1,
                limit: 100,
                customerId: customerId
                // status: DepositOrderStatus.Pending,
              });
            case 2:
              res = _context5.sent;
              this.depositOrders = res.data.depositOrders;
              if (!this.form.depositOrderId && !!((_res$data$depositOrde = res.data.depositOrders) !== null && _res$data$depositOrde !== void 0 && _res$data$depositOrde.length)) {
                this.$set(this.form, "depositOrderId", res.data.depositOrders[0].id);
                this.handleChangeDepositOrder();
              } else if (!!this.form.depositOrderId) {
                find = this.depositOrders.find(function (e) {
                  return e.id == _this5.form.depositOrderId;
                });
                this.$set(this.form, "depositOrderDetails", find.depositOrderDetails);
              }
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function fetchListDepositOrder(_x) {
        return _fetchListDepositOrder.apply(this, arguments);
      }
      return fetchListDepositOrder;
    }()
  }, {
    key: "fetchCustomers",
    value: function fetchCustomers() {
      var _this6 = this;
      _customer.customerApi.findAll({
        isExistConSign: this.type == _order.OrderType.Consign
      }).then(function (res) {
        _this6.customers = res.data.customers;
      });
    }
  }, {
    key: "fetchSkins",
    value: function fetchSkins() {
      var _this7 = this;
      _skinStatus.skinStatusApi.findAll().then(function (res) {
        _this7.skins = res.data.skinStatuses;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  required: true
})], CustomerOrderForm.prototype, "form", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({})], CustomerOrderForm.prototype, "orderStatus", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerOrderForm.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerOrderForm.prototype, "checkCustomerMonthBirthday", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerOrderForm.prototype, "disabled", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerOrderForm.prototype, "compare", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerOrderForm.prototype, "statusForm", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.addressCityId")], CustomerOrderForm.prototype, "watchCity", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.addressDistrictId")], CustomerOrderForm.prototype, "watchDistrictId", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("districts")], CustomerOrderForm.prototype, "watchDistrict", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.customerId", {
  immediate: true
})], CustomerOrderForm.prototype, "watchCustomerId", null);
CustomerOrderForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    CustomerDialog: function CustomerDialog() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/customer/components/CustomerDialog.vue"));
      });
    }
  }
})], CustomerOrderForm);
var _default = exports.default = CustomerOrderForm;